import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	title: {
		fontWeight: 400,
		fontSize: 14,
		color: colors.gray[600]
	},
	percentageBarContainer: {
		height: 40,
		borderRadius: 4,
		overflow: "hidden",
		boxShadow: `0px 2px 2px 0px ${colors.gray[100]}`,
		border: `1px solid ${colors.gray[100]}`
	},
	percentageBarItem: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		boxSizing: "border-box"
	}
}))

export default useStyles
